import GroupPointBasedRulesDataModel from './GroupPointBasedRulesDataModel';

/**
 * The lowest and highest totals a point based model can produce.
 *
 * Each group is one CASE whose first matching rule wins and whose ELSE is 0,
 * so a group contributes one of its rules' points or nothing. The extremes are
 * therefore each group's lowest and highest option, 0 included, summed. This
 * is the scale the thresholds cut: a point based score is never smoothed.
 */
export function pointsRange(
  groups: Pick<GroupPointBasedRulesDataModel, 'rules'>[]
): {
  min: number;
  max: number;
} {
  return groups.reduce(
    (range, group) => {
      const options = [
        0,
        ...(group.rules ?? []).map((rule) => Number(rule.points) || 0),
      ];
      return {
        min: range.min + Math.min(...options),
        max: range.max + Math.max(...options),
      };
    },
    { min: 0, max: 0 }
  );
}

/** Points as every point based surface states them: the sign always shown. */
export function signedPoints(points: number): string {
  return points > 0 ? `+${points}` : String(points);
}
